import NotificationActions from '../../../actions/NotificationActions';
import PrintActions from '../../../actions/PrintActions';
import PosActions from '../../../actions/PosActions';
import PopupActions from '../../../actions/PopupActions';
import GuestActions from '../../../actions/GuestActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import DropdownProfile from './DropdownProfile.react';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';
import AjaxPromises from '../../../utils/AjaxPromises';

// import ReturnForm from './ReturnForm.react';

class AdjustLoyaltyPoints extends React.Component {

    constructor(props) {
        super(props);

           this.state = {
            loading     : false,
            visible     : false,
            pin    : '',
            allotment   : 0,
            unit : 'g',
            units : ['g', 'oz'],
            currentAllotmentDisplay : this.props.current
            // loyalty     : this.props.guest.LoyaltyPoints
        }

        this.adjust = this.adjust.bind(this);
        this.open = this.open.bind(this);
        this.isValid = this.isValid.bind(this);
        this.canAdjust = this.canAdjust.bind(this);
        this.checkManagerPin = this.checkManagerPin.bind(this);
        this.onChangeUnit = this.onChangeUnit.bind(this);
    }

    open() {
        if (!this.canAdjust()) {
            return false;
        }

        this.setState({ visible : true });
    }

    isValid() {
        var guest = this.props.guest;

        if (this.state.pin.length < 1 && this.requireManagerPin()) {
            return false;
        }

        if (guest.Allotment == this.state.allotment) {
            return false;
        }

        return true;
    }

    canAdjust() {

        return true;
    }

    checkManagerPin() {
        var self = this;

        if(!self.requireManagerPin()) {
            self.adjust();
            return;
        }

        if (this.state.pin.length < 1) {
            NotificationActions.addNotification({ type : 'alert', body : 'Manager PIN Missing' });
            return;
        }

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, UserStore.getApiData({
            ShipmentId : this.props.guest.ShipmentId,
            PinCode : this.state.pin
        })).then(res => {
            if (res.Data[0].MgrPermission === true) {
                self.adjust();
            } else {
                NotificationActions.addNotification({ type : 'alert', body : 'Invalid PIN' });
            }
        })
    }

    adjust() {

        var guest = this.props.guest;
        var conversionFactor = 28.35;
        var allotmentValue = this.state.allotment;
        if (this.state.unit == 'oz') {
            allotmentValue = this.state.allotment * conversionFactor;
        }

        if (allotmentValue.length < 1) {
            return;
        }

        if (parseFloat(allotmentValue).toFixed(2) < 0) {
            return;
        }

        var url = GuestEndPoints.SET_CURRENT_ALLOTMENT
        if (this.props.type === 'max') {
            url = GuestEndPoints.SET_MAX_ALLOTMENT;
        }

        AjaxPromises.POST(url, UserStore.getApiData({
            PatientId : guest.Guest_id,
            Allotment : allotmentValue
        })).then(res => {
            NotificationActions.addNotification({
                type : res.Result ? 'success' : 'error',
                body : res.Result ? 'Allotment adjusted' : 'Failed to adjust allotment'
            });

            this.setState({ currentAllotmentDisplay : allotmentValue, allotment: 0, unit: 'g' });

            if (res.Result) {
                this.setState({
                    loading : false,
                    visible : false,
                    pin : '',
                    allotment : 0
                });

                GuestActions.loadFullGuest(guest.Guest_id);
                this.props.onClose();
            } else {
                this.setState({ loading : false });
            }
        });
    }

    onChange(e) {
        let value = e.target.value
        if (value > 100000) {
            return;
        }
        this.setState({ allotment : value });
    }

    onChangeUnit(field, val) {
        var conversion = this.state.allotment;
        var conversionFactor = 28.35;
        var currentAllotment = this.state.currentAllotmentDisplay;
        if (this.state.unit === 'g' && val === 'oz') {
            currentAllotment = parseFloat((currentAllotment / conversionFactor).toFixed(4));
        }
        if (this.state.unit === 'oz' && val === 'g') {
            currentAllotment = this.props.guest.Allotment;
        }
        this.setState({ unit : val });
        this.setState({ currentAllotmentDisplay : currentAllotment});
    }

    requireManagerPin() {
        return UserStore.getState().selectedLocation.RequireManagerPasswordForAllotmentAdjust;
    }

    render() {
        var self = this;
        var valid = this.isValid();
        var type = (this.props.type || '').toUpperCase();

        return (
            <div className='col-6'>
                <div className='popup popup__transparent'>
                    <div className='popup__content adjust-loyalty'>

                        <div className='popup-header'>
                            ADJUST {type} ALLOTMENT

                            <div
                                className='popup-close'
                                onClick={() => { 
                                    this.setState({ pin : '', loyalty : 0 });
                                    this.props.onClose();
                                 }}>

                                <i className='fa fa-times' aria-hidden='true' />
                            </div>
                        </div>

                        <div className='adjust-loyalty__content container'>
                            <div className='row' style={{'height':'54px'}}>
                                <div className='col-6'>
                                    Current Amount
                                </div>
                                    {this.state.currentAllotmentDisplay}{this.state.unit}
                            </div>
                            <div className='row'>
                                <div className='col-6'>
                                    Adjust to
                                </div>
                                <div className='col-3 adjust-loyalty__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.allotment}
                                        className='input-text-1'
                                        onChange={self.onChange.bind(self)} />
                                </div>
                                <div className='col-xs-2 adjust-loyalty__padding-0'>
                                <DropdownProfile
                                field='unit'
                                options={[
                                    { title: 'g', option: 'g' },
                                    { title: 'oz', option: 'oz' },

                                ]}
                                selected={this.state.unit}
                                onChange={this.onChangeUnit} />
                                </div>
                            </div>
                            {
                                this.requireManagerPin() && 
                                <div className='row'>
                                    <div className='col-md-6'>
                                        Manager PIN
                                    </div>
                                    <div className='col-md-5 adjust-loyalty__padding-0'>
                                        <input
                                            type='password'
                                            value={this.state.pin}
                                            className='input-text-1'
                                            onChange={(e) => { this.setState({ pin : e.target.value }); }} />
                                    </div>
                                </div>
                            }

                            <div className='row'>
                                <div className='col-9'>
                                    
                                </div>
                                <div className='col-2'>
                                    <div
                                        className={'adjust-loyalty__ok btn-green '+(!valid ? 'btn-green__disabled' : '')}
                                        onClick={self.checkManagerPin}>
                                        Adjust
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdjustLoyaltyPoints;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/AdjustAllotment.react.jsx